import { WithdrawRequest } from '../types'

/** The row an action returned, keeping what the action response leaves out.
 *
 *  Approve, Pay now, Revoke, Decline and Resolve answer with the request alone:
 *  `account_flags` (the ban and the staff tags beside the name) comes from the
 *  list, so swapping the row for the response made those pills vanish the
 *  moment a reviewer acted on it (audit B-c22, PAY-17). The facts did not
 *  change; only the response was smaller. A response that does carry flags
 *  wins, because it is newer. */
export const keepStaffContext = (previous: WithdrawRequest, returned: WithdrawRequest): WithdrawRequest => ({
    ...returned,
    account_flags: returned.account_flags ?? previous.account_flags,
})
